(function(i,s,o,g,r,a,m){i['SplititObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window, document, 'script', '//upstream.production.splitit.com/v1/dist/upstream-messaging.js?v='+(Math.ceil(new Date().getTime()/100000)), 'splitit');
splitit('init', { apiKey: '20640dea-7f1e-48db-8222-6eb29930f8f2', lang: 'en', currency: 'CAD', currencySymbol: '$', debug: true });

let initialURL = document.URL
function splititPdpVariant() {
  var variantId = ShopifyAnalytics && ShopifyAnalytics.meta.selectedVariantId;
  var productVariants = getVariants();
    
  var productVariant = productVariants.find(function (variant) {
    return variant.id == variantId;
  })

  if (!productVariant) return;

  var variantPrice = productVariant.price;
  var priceMoney = variantPrice / 100;
  // Set the data attribute with new value
  document.querySelector("#splitit-container").setAttribute('data-splitit-amount', priceMoney);
  // Render placement with new information
  splitit && splitit.ui.refresh();
}

function getVariants() {
  return ShopifyAnalytics && ShopifyAnalytics.meta.product.variants;
}

function splititInit() {
  var productUrl = document.URL;
  document.addEventListener('change', function () {
    var currentUrl = document.URL;
    var url = new URL(currentUrl);
    // var isVariantUrl = url.searchParams.get("variant");
    // currentUrl = isVariantUrl ? currentUrl : isVariantUrl;
    if (currentUrl != initialURL) {
      initialURL = currentUrl;
      splititPdpVariant();
    }
  });
}
splititInit();